
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api';
import qs from 'qs';
const baseUrl = '0330FB';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '首页',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '先进事迹',
      path: `/${baseUrl}/deeds`,
      id: 2,
    },
    {
      title: '相关新闻',
      path: `/${baseUrl}/news`,
      id: 3,
    },
    {
      title: '缅怀留言',
      path: `/${baseUrl}/message`,
      id: 4,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '我们不会忘记',
      url: location.href,
      subtitle: `缅怀脱贫攻坚英雄，建功乡村振兴事业`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '我们不会忘记',
        subtitle: `缅怀脱贫攻坚英雄，建功乡村振兴事业`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
    const unionid = window.localStorage.getItem('unionid');
    if (isWeiXin() && !unionid) {
      this.WechatLogin();
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
